import { render, staticRenderFns } from "./PaginaSIAE.vue?vue&type=template&id=63848647"
import script from "./PaginaSIAE.vue?vue&type=script&lang=js"
export * from "./PaginaSIAE.vue?vue&type=script&lang=js"
import style0 from "./PaginaSIAE.vue?vue&type=style&index=0&id=63848647&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports